import { render, staticRenderFns } from "./XjBottom.vue?vue&type=template&id=14f3cd88&scoped=true&"
import script from "./XjBottom.vue?vue&type=script&lang=js&"
export * from "./XjBottom.vue?vue&type=script&lang=js&"
import style0 from "./XjBottom.vue?vue&type=style&index=0&id=14f3cd88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f3cd88",
  null
  
)

export default component.exports